import { render } from "./CashClosingDetail.vue?vue&type=template&id=4fc4dbaf"
import script from "./CashClosingDetail.vue?vue&type=script&lang=js"
export * from "./CashClosingDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__